const variables = {
  mainNavigationLargeHeight: 120,
  mainNavigationLargeMarginTop: 0,
  mainNavigationLargeProfileMenuButtonVariant: 'ghost',
  mainNavigationSmallHeight: 56,
  mainNavigationSmallMarginTop: 8,
  mainNavigationSmallProfileMenuButtonVariant: 'ghost',
};

export default variables;
